var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 124,
    viewBox: "0 0 200 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 123.077,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1138 23.4277C42.1539 16.9785 44.0523 12.9631 45.8062 11.38C50.6631 6.99849 57.3785 9.3831 58.8062 9.72464C63.8215 10.9277 62.1908 3.0108 66.4938 1.40156C69.3615 0.329257 71.72 1.64003 73.5708 5.33387C75.2092 1.88772 77.7062 0.309257 81.0615 0.590796C86.0954 1.01695 87.8569 18.0185 94.7738 14.2969C101.692 10.5739 110.174 9.7231 113.797 15.2554C114.58 16.4523 114.88 14.5954 120.206 8.25541C125.532 1.91387 130.843 -0.879973 141.738 2.81233C146.692 4.48926 150.766 9.03541 153.965 16.4493C153.965 27.0308 161.749 33.2954 177.315 35.2385C200.668 38.1539 182.542 63.26 153.965 70.6123C125.386 77.9662 59.5908 81.9354 23.8862 63.3569C0.0830784 50.9739 5.49231 37.6631 40.1123 23.4277H40.1138Z",
    fill: "url(#paint0_linear_3371_82473)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6677 116.935C122.447 116.935 141.725 112.473 141.725 106.969C141.725 101.465 122.447 97.0031 98.6677 97.0031C74.888 97.0031 55.6108 101.465 55.6108 106.969C55.6108 112.473 74.888 116.935 98.6677 116.935Z",
    fill: "url(#paint1_linear_3371_82473)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.675,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.36 119.405C138.986 127.525 28.4831 118.237 16.7215 113.995C10.9969 111.929 5.83691 108.045 1.24307 102.34C0.728913 101.702 0.405735 100.932 0.310878 100.118C0.216021 99.3043 0.353357 98.4803 0.707015 97.7413C1.06067 97.0023 1.61622 96.3784 2.30946 95.9418C3.00269 95.5052 3.80533 95.2736 4.6246 95.2739H197.723C201.731 105.948 192.943 113.991 171.36 119.405Z",
    fill: "url(#paint2_linear_3371_82473)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.708 80.26L116.983 63.0416C116.635 62.6308 116.202 62.3 115.714 62.0716C115.227 61.8433 114.695 61.7229 114.157 61.7185H82.4954C81.4092 61.7185 80.3769 62.217 79.6692 63.0416L64.9446 80.26V89.7124H131.708V80.26Z",
    fill: "url(#paint3_linear_3371_82473)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127.535 90.06L114.648 75.0631C114.336 74.709 113.952 74.4261 113.521 74.2337C113.091 74.0412 112.624 73.9437 112.152 73.9477H84.5C83.5508 73.9477 82.6231 74.3416 82.0046 75.0631L69.1169 90.06V98.297H127.535V90.06Z",
    fill: "url(#paint4_linear_3371_82473)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M131.708 100.545C131.708 101.857 131.117 103.037 130.185 103.828L129.995 103.982C129.256 104.542 128.354 104.844 127.426 104.843H69.2277C68.7015 104.843 68.1985 104.748 67.7338 104.572L67.5031 104.48C66.7417 104.141 66.0949 103.589 65.6408 102.89C65.1867 102.192 64.9449 101.376 64.9446 100.543V80.3631H81.1431C82.9323 80.3631 84.3738 81.8354 84.3738 83.6216V83.6447C84.3738 85.4324 85.8323 86.8739 87.6215 86.8739H109.031C109.891 86.8731 110.715 86.5315 111.324 85.9239C111.933 85.3164 112.276 84.4924 112.278 83.6324C112.278 81.8385 113.722 80.3631 115.509 80.3631H131.709L131.708 100.545Z",
    fill: "url(#paint5_linear_3371_82473)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3371_82473",
    x1: 102.869,
    y1: 57.405,
    x2: 102.869,
    y2: -12.8773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEDE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9A9",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3371_82473",
    x1: 94.1812,
    y1: 116.935,
    x2: 94.1812,
    y2: 97.0031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96A1C5",
    stopOpacity: 0.373
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3371_82473",
    x1: 99.4731,
    y1: 122.625,
    x2: 99.4731,
    y2: 89.8925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919191",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3371_82473",
    x1: 98.3261,
    y1: 61.7185,
    x2: 98.3261,
    y2: 74.3017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5389F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#416FDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3371_82473",
    x1: 106.122,
    y1: 98.297,
    x2: 106.122,
    y2: 72.6532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3371_82473",
    x1: 98.3269,
    y1: 80.3631,
    x2: 98.3269,
    y2: 104.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CA5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4D6FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.6a58930076dce54c9ed5ff34a2dcb5d4.svg";
export { ForwardRef as ReactComponent };